module.exports = __webpack_public_path__ + "img/synapse-homepage12.1724d394.png";